var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { "align-center": "" } },
    [
      _c(
        "v-item-group",
        {
          staticClass: "shrink mr-4",
          attrs: { mandatory: "", tag: "v-flex" },
          model: {
            value: _vm.window,
            callback: function ($$v) {
              _vm.window = $$v
            },
            expression: "window",
          },
        },
        [
          !_vm.hideMetrics
            ? _c("v-item", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active, toggle }) {
                        return _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", "input-value": active },
                                on: { click: toggle },
                              },
                              [_c("h6", [_vm._v(" Metrics ")])]
                            ),
                          ],
                          1
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  2878718965
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideCollectorLogs
            ? _c("v-item", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ active, toggle }) {
                        return _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { text: "", "input-value": active },
                                on: { click: toggle },
                              },
                              [_c("h6", [_vm._v(" Logs from collector box ")])]
                            ),
                          ],
                          1
                        )
                      },
                    },
                  ],
                  null,
                  false,
                  1339042901
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("v-item", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", "input-value": active },
                          on: { click: toggle },
                        },
                        [_c("h6", [_vm._v(" Server Logs (Elk) ")])]
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("v-item", {
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ active, toggle }) {
                  return _c(
                    "div",
                    {},
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", "input-value": active },
                          on: { click: toggle },
                        },
                        [_c("h6", [_vm._v(" Realtime Data Feed ")])]
                      ),
                    ],
                    1
                  )
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        [
          _c(
            "v-window",
            {
              staticClass: "elevation-1",
              attrs: { vertical: "" },
              model: {
                value: _vm.window,
                callback: function ($$v) {
                  _vm.window = $$v
                },
                expression: "window",
              },
            },
            [
              !_vm.hideMetrics
                ? _c(
                    "v-window-item",
                    [
                      _c("collector-metrics", {
                        attrs: {
                          keylike: _vm.metricsKeyLike,
                          srcIdFilter: _vm.metricsSrcIdFilter,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hideCollectorLogs
                ? _c(
                    "v-window-item",
                    [
                      _c("collector-logs", {
                        attrs: {
                          filter: _vm.logFilter,
                          numRowsPerPage: [5],
                          rowsPerPage: 5,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-window-item",
                [
                  _c("elk-logs", {
                    attrs: {
                      srcIdFilter: _vm.logSrcIdFilter,
                      numRowsPerPage: [5],
                      rowsPerPage: 5,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-window-item",
                [
                  _c("system-rt-logs", {
                    attrs: { srcIdFilter: _vm.logSrcIdFilter, rowsPerPage: 5 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }